import {
  Component, Vue, Prop, Mixins,
} from 'vue-property-decorator';
import MyCommon from './common';

@Component
export default class MyForm extends Mixins(MyCommon) {
    // form!: any
    formData: { [t: string]: any } = {}

    @Prop() editId!: number
}
